'use client';

import { useEffect, useState } from 'react';

const HEADER_NAV_SELECTOR = '[data-header-nav]';

export function useStickyHeaderOffset() {
  const [stickyTopOffset, setStickyTopOffset] = useState<string | undefined>(undefined);

  useEffect(() => {
    const headerNav = document.querySelector<HTMLElement>(HEADER_NAV_SELECTOR);
    if (!headerNav) {
      setStickyTopOffset('0px');
      return;
    }

    const update = () => {
      const height = Math.round(headerNav.getBoundingClientRect().height);
      setStickyTopOffset(`${height}px`);
    };

    const resizeObserver = new ResizeObserver(update);
    resizeObserver.observe(headerNav);
    update();

    return () => resizeObserver.disconnect();
  }, []);

  return stickyTopOffset;
}
